<template>
  <ul class="pagination">
    <li class="waves-effect" :class="{ disabled: pagina_atual == 1 }">
      <a href="#!" @click="mudarDePagina(pagina_atual-1)"><i class="material-icons">chevron_left</i></a>
    </li>
    <li class="waves-effect" :class="{ active: pagina == pagina_atual }" v-for="pagina in paginas">
      <a href="#!" @click="mudarDePagina(pagina)">{{ pagina }}</a>
    </li>
    <li class="waves-effect" :class="{ disabled: pagina_atual == ultima_pagina }">
      <a href="#!" @click="mudarDePagina(pagina_atual+1)"><i
          class="material-icons">chevron_right</i></a>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      'pagina_atual': {
        default: 1
      },
      'ultima_pagina': {
        default: 0
      }
    },
    methods: {
      mudarDePagina(pagina) {
        if (pagina > 0 && pagina <= this.ultima_pagina) {
          this.$emit('mudar-pagina', pagina);
        }
      },
    },
    computed: {
      paginas() {
        let paginas = [];
        let on_each_side = 3;

        if (this.ultima_pagina < (on_each_side * 2) + 6) {
          for (let i = 1; i <= this.ultima_pagina; i++) {
            paginas.push(i);
          }

          return paginas;
        }

        let window = on_each_side * 2;

        if (this.ultima_pagina <= 1) {
          return [];
        }

        // If the current page is very close to the beginning of the page range, we will
        // just render the beginning of the page range, followed by the last 2 of the
        // links in this list, since we will not have room to create a full slider.
        if (this.pagina_atual <= window) {
          for (let i = 1; i <= window + 2; i++) {
            paginas.push(i);
          }
          paginas.push('...');

          paginas.push(this.ultima_pagina - 1);
          paginas.push(this.ultima_pagina);

          return paginas;
        }

        // If the current page is close to the ending of the page range we will just get
        // this first couple pages, followed by a larger window of these ending pages
        // since we're too close to the end of the list to create a full on slider.
        else if (this.pagina_atual > (this.ultima_pagina - window)) {
          paginas.push(1);
          paginas.push(2);

          paginas.push('...');

          for (let i = this.ultima_pagina - (window + 2); i <= this.ultima_pagina; i++) {
            paginas.push(i);
          }

          return paginas;
        }

        // If we have enough room on both sides of the current page to build a slider we
        // will surround it with both the beginning and ending caps, with this window
        // of pages in the middle providing a Google style sliding paginator setup.
        paginas.push(1);
        paginas.push(2);

        paginas.push('...');

        for (let i = this.pagina_atual - on_each_side; i <= this.pagina_atual + on_each_side; i++) {
          paginas.push(i);
        }

        paginas.push('...');

        paginas.push(this.ultima_pagina - 1);
        paginas.push(this.ultima_pagina);

        return paginas;
      },
    }
  }
</script>
<style scoped>
  .badge-block {
    border: 0px solid;
    display: inline-block;
    min-width: 75px;
    margin-right: 15px !important;
    text-align: center;
  }

  .my-badge {
    float: left !important;
    margin-left: 0px !important;
    min-width: inherit;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/common/Paginacao.vue